var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 2.5H2.5V8.75H8.75V2.5Z",
    stroke: "#1E201C",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2.5H11.25V8.75H17.5V2.5Z",
    stroke: "#1E201C",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 11.25H2.5V17.5H8.75V11.25Z",
    stroke: "#1E201C",
    strokeWidth: 1.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11.25H11.25V17.5H17.5V11.25Z",
    stroke: "#1E201C",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDashboard);
export default __webpack_public_path__ + "static/media/menu-dashboard.ab759a5c52e9d80ac09ad2079d671d8f.svg";
export { ForwardRef as ReactComponent };